import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/community/events";

export const Route = createFileRoute("/admin/_modules/community-events")({
  component: Page,
});
